import React, { useEffect, useState } from 'react';
import { Clock, ShieldCheck, AlertTriangle, ChevronDown, Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 32
  });
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [selectedPlan, setSelectedPlan] = useState<'pro' | 'basic'>('pro');
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  const faqs = [{
    q: '¿Sirve si no sé nada de mecánica?',
    a: 'Sí. Está diseñado exactamente para conductores sin conocimiento técnico. No necesitás saber mecánica para usarlo. Solo seguís el protocolo y obtenés el resultado.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Después del pago recibís un link de acceso inmediato a todos los PDFs. En menos de 5 minutos tenés todo disponible en tu celular o computadora.'
  }, {
    q: '¿Sirve para cualquier modelo de auto?',
    a: 'Sí. Los protocolos, checklists y guías funcionan para cualquier auto a nafta, GNC o diesel de cualquier marca y año.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% del dinero sin preguntas.'
  }];
  return <section id="pricing" className="py-24 bg-surface border-t border-white/5 relative overflow-hidden" data-id="element-188">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[500px] bg-cyan/5 rounded-full blur-[150px] pointer-events-none" aria-hidden="true" data-id="element-189"></div>

      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-190">
        {/* Countdown */}
        <FadeIn data-id="element-191">
          <div className="text-center mb-16" data-id="element-192">
            <h2 className="text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-193">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h2>

            <div className="flex justify-center gap-4 mb-6" data-id="element-194">
              <div className="bg-background border border-cyan/30 w-20 h-24 md:w-24 md:h-28 rounded-xl flex flex-col items-center justify-center shadow-[0_0_15px_rgba(45,125,210,0.1)]" data-id="element-195">
                <span className="text-4xl md:text-5xl font-bold text-cyan font-heading" data-id="element-196">
                  {formatTime(timeLeft.h)}
                </span>
                <span className="text-xs text-gray-400 uppercase mt-2" data-id="element-197">
                  Horas
                </span>
              </div>
              <div className="text-4xl md:text-5xl font-bold text-cyan/50 self-center pb-6" aria-hidden="true" data-id="element-198">
                :
              </div>
              <div className="bg-background border border-cyan/30 w-20 h-24 md:w-24 md:h-28 rounded-xl flex flex-col items-center justify-center shadow-[0_0_15px_rgba(45,125,210,0.1)]" data-id="element-199">
                <span className="text-4xl md:text-5xl font-bold text-cyan font-heading" data-id="element-200">
                  {formatTime(timeLeft.m)}
                </span>
                <span className="text-xs text-gray-400 uppercase mt-2" data-id="element-201">
                  Min
                </span>
              </div>
              <div className="text-4xl md:text-5xl font-bold text-cyan/50 self-center pb-6" aria-hidden="true" data-id="element-202">
                :
              </div>
              <div className="bg-background border border-cyan/30 w-20 h-24 md:w-24 md:h-28 rounded-xl flex flex-col items-center justify-center shadow-[0_0_15px_rgba(45,125,210,0.1)]" data-id="element-203">
                <span className="text-4xl md:text-5xl font-bold text-cyan font-heading" data-id="element-204">
                  {formatTime(timeLeft.s)}
                </span>
                <span className="text-xs text-gray-400 uppercase mt-2" data-id="element-205">
                  Seg
                </span>
              </div>
            </div>

            <div className="inline-flex items-center gap-2 text-yellow bg-yellow/10 px-4 py-2 rounded-full text-sm font-medium mb-6" data-id="element-206">
              <AlertTriangle className="w-4 h-4" aria-hidden="true" data-id="element-207" />
              ⚠️ Después sube $8.000 ARS. No vuelve.
            </div>

            {/* Scarcity Bar */}
            <div className="max-w-md mx-auto bg-surfaceLight/50 rounded-xl p-4 border border-red-500/20" data-id="element-208">
              <div className="flex items-center justify-between mb-2" data-id="element-209">
                <span className="text-red-400 font-bold text-sm flex items-center gap-2" data-id="element-210">
                  <span className="relative flex h-2 w-2" aria-hidden="true" data-id="element-211">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-212"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-213"></span>
                  </span>
                  🔴 Quedan pocos cupos al precio de lanzamiento
                </span>
              </div>
              <div className="w-full bg-background rounded-full h-2.5 mb-2 overflow-hidden border border-white/5" role="progressbar" aria-valuenow={71} aria-valuemin={0} aria-valuemax={100} aria-label="71% de los cupos ya tomados" data-id="element-214">
                <div className="bg-gradient-to-r from-red-500 to-red-400 h-2.5 rounded-full" style={{
                width: '71%'
              }} data-id="element-215"></div>
              </div>
              <p className="text-xs text-gray-400 text-right" data-id="element-216">
                71% de los cupos ya tomados
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Pricing Selector */}
        <FadeIn delay={0.1} data-id="element-217">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-10" data-id="element-218">
            ELEGÍ TU <span className="text-cyan" data-id="element-219">MEGA PACK</span>
          </h2>
        </FadeIn>

        <div id="elegir-plan" className="max-w-2xl mx-auto mb-24" role="radiogroup" aria-label="Selección de plan" data-id="element-220">
          {/* Basic Plan Option */}
          <FadeIn delay={0.1} data-id="element-221">
            <button onClick={() => setSelectedPlan('basic')} role="radio" aria-checked={selectedPlan === 'basic'} className={`w-full text-left rounded-2xl p-6 mb-4 transition-all duration-300 border-2 ${selectedPlan === 'basic' ? 'border-cyan shadow-[0_0_25px_rgba(45,125,210,0.15)] bg-surfaceLight/60' : 'border-white/10 bg-background hover:border-white/20'}`} data-id="element-222">
              <div className="flex items-start gap-4" data-id="element-223">
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'basic' ? 'border-cyan' : 'border-gray-500'}`} data-id="element-224">
                  {selectedPlan === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-cyan" data-id="element-225"></div>}
                </div>
                <div className="flex-1 min-w-0" data-id="element-226">
                  <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-227">
                    <div data-id="element-228">
                      <h3 className="text-xl font-bold text-white flex items-center gap-2 mb-1" data-id="element-229">
                        <span data-id="element-230">📘</span> MEGA PACK AUTO BLINDADO™
                      </h3>
                      <p className="text-gray-400 text-sm mb-3" data-id="element-231">
                        6 Módulos + 5 Bonos
                      </p>
                      <div className="bg-surfaceLight/50 px-3 py-2 rounded-lg border border-white/5 text-xs text-gray-300 inline-block" data-id="element-232">
                        <span className="font-semibold text-white" data-id="element-233">
                          Ideal para:
                        </span>{' '}
                        Dueños de auto usado que quieren control total sin
                        depender de mecánicos
                      </div>
                    </div>
                    <div className="sm:text-right shrink-0" data-id="element-234">
                      <span className="text-gray-400 line-through text-sm block" data-id="element-235">
                        $51.000
                      </span>
                      <span className="text-3xl font-bold text-white font-heading" data-id="element-236">
                        $19.990
                      </span>
                      <span className="text-sm text-gray-400 ml-1" data-id="element-237">ARS</span>
                    </div>
                  </div>
                </div>
              </div>
            </button>
          </FadeIn>

          {/* Pro Plan Option */}
          <FadeIn delay={0.2} data-id="element-238">
            <div className="relative" data-id="element-239">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-240">
                <span className="bg-cyan text-background font-bold px-4 py-1 rounded-full text-xs uppercase tracking-wider" data-id="element-241">
                  Más Elegido ⭐
                </span>
              </div>
              <button onClick={() => setSelectedPlan('pro')} role="radio" aria-checked={selectedPlan === 'pro'} className={`w-full text-left rounded-2xl p-6 transition-all duration-300 border-2 ${selectedPlan === 'pro' ? 'border-cyan shadow-[0_0_25px_rgba(45,125,210,0.15)] bg-surfaceLight/60' : 'border-white/10 bg-background hover:border-white/20'}`} data-id="element-242">
                <div className="flex items-start gap-4" data-id="element-243">
                  <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'pro' ? 'border-cyan' : 'border-gray-500'}`} data-id="element-244">
                    {selectedPlan === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-cyan" data-id="element-245"></div>}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-246">
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-247">
                      <div data-id="element-248">
                        <h3 className="text-xl font-bold text-white flex items-center gap-2 mb-1" data-id="element-249">
                          <span data-id="element-250">🏆</span> MEGA PACK + MECÁNICA DE GUERRA 24/7™{' '}
                          <span className="text-yellow" data-id="element-251">⭐</span>
                        </h3>
                        <p className="text-cyan text-sm font-medium mb-3" data-id="element-252">
                          6 Módulos + 5 Bonos + Sistema de Emergencia Avanzado
                        </p>
                        <div className="bg-cyan/5 px-3 py-2 rounded-lg border border-cyan/20 text-xs text-gray-300 inline-block" data-id="element-253">
                          <span className="font-semibold text-white" data-id="element-254">
                            Ideal para:
                          </span>{' '}
                          Conductores que quieren estar preparados para
                          cualquier situación crítica en ruta, de noche o lejos
                          de cualquier taller
                        </div>
                      </div>
                      <div className="sm:text-right shrink-0" data-id="element-255">
                        <span className="text-gray-400 line-through text-sm block" data-id="element-256">
                          $79.000
                        </span>
                        <span className="text-3xl font-bold text-cyan font-heading" data-id="element-257">
                          $29.990
                        </span>
                        <span className="text-sm text-cyan ml-1" data-id="element-258">ARS</span>
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </FadeIn>

          {/* Single CTA Button */}
          <FadeIn delay={0.3} data-id="element-259">
            <a href={selectedPlan === 'pro' ? 'https://fegion.shop/cart/46660942037131:1' : 'https://fegion.shop/cart/46660935221387:1'} className="block w-full mt-6 py-5 text-center rounded-2xl font-bold text-background bg-cyan hover:bg-cyan/90 transition-all animate-pulse-glow shadow-[0_0_20px_rgba(45,125,210,0.4)] uppercase tracking-wider text-lg" aria-label={selectedPlan === 'pro' ? 'Comprar Mega Pack más Mecánica de Guerra' : 'Comprar Mega Pack Básico'} data-id="element-260">
              {selectedPlan === 'pro' ? '→ QUIERO EL MEGA PACK + MECÁNICA DE GUERRA 24/7™' : '→ QUIERO MI MEGA PACK AHORA'}
            </a>
          </FadeIn>
        </div>

        {/* Comparison Table */}
        <FadeIn delay={0.2} data-id="element-261">
          <div className="max-w-4xl mx-auto mb-16" data-id="element-262">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2 text-center" data-id="element-263">
              🔧 ¿QUÉ AGREGA MECÁNICA DE GUERRA 24/7™?
            </h3>
            <p className="text-gray-400 text-center mb-6" data-id="element-264">
              El sistema completo para salir de cualquier emergencia sin grúa,
              sin pánico y sin depender de nadie
            </p>
            <p className="text-sm text-gray-400 mb-2 md:hidden text-center" aria-hidden="true" data-id="element-265">
              ← Scroll to see full table →
            </p>
            <div className="overflow-x-auto pb-4" data-id="element-266">
              <table className="w-full min-w-[600px] text-left border-collapse" data-id="element-267">
                <caption className="sr-only" data-id="element-268">
                  Comparación entre tener y no tener Mecánica de Guerra 24/7
                </caption>
                <thead data-id="element-269">
                  <tr data-id="element-270">
                    <th className="p-4 border-b border-white/10 text-gray-300 font-semibold bg-surfaceLight/30 rounded-tl-xl" data-id="element-271">
                      Situación
                    </th>
                    <th className="p-4 border-b border-white/10 text-red-400 font-semibold bg-red-500/5" data-id="element-272">
                      ❌ Sin Mecánica de Guerra
                    </th>
                    <th className="p-4 border-b border-white/10 text-cyan font-semibold bg-cyan/5 rounded-tr-xl" data-id="element-273">
                      ✅ Con Mecánica de Guerra
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm md:text-base" data-id="element-274">
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-275">
                    <td className="p-4 text-gray-300" data-id="element-276">
                      Quedás tirado en ruta de noche y no sabés qué hacer
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-277">
                      Llamás a la grúa y esperás horas en la oscuridad
                    </td>
                    <td className="p-4 text-white bg-cyan/5 font-medium" data-id="element-278">
                      Protocolo de emergencia nocturna paso a paso. Listo.
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-279">
                    <td className="p-4 text-gray-300" data-id="element-280">
                      El auto hace un ruido extraño en plena autopista
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-281">
                      Parás o seguís rezando que llegue
                    </td>
                    <td className="p-4 text-white bg-cyan/5 font-medium" data-id="element-282">
                      Diagnóstico de ruidos en movimiento. Sabés qué hacer en 3
                      minutos.
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-283">
                    <td className="p-4 text-gray-300" data-id="element-284">
                      Se te va la batería lejos de una ciudad
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-285">
                      Esperás que alguien pare a ayudarte
                    </td>
                    <td className="p-4 text-white bg-cyan/5 font-medium" data-id="element-286">
                      Protocolo de arranque de emergencia sin asistencia. Listo.
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-287">
                    <td className="p-4 text-gray-300" data-id="element-288">
                      Una luz roja se enciende en el tablero en ruta
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-289">
                      Pánico total. ¿Parás? ¿Seguís? No sabés
                    </td>
                    <td className="p-4 text-white bg-cyan/5 font-medium" data-id="element-290">
                      Árbol de decisión por luz y síntoma. Decisión correcta en
                      60 segundos.
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-291">
                    <td className="p-4 text-gray-300" data-id="element-292">
                      El auto se recalienta en el medio de la nada
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-293">
                      No sabés si apagarlo, seguir o explotar
                    </td>
                    <td className="p-4 text-white bg-cyan/5 font-medium" data-id="element-294">
                      Protocolo anti-recalentamiento de emergencia. Paso a paso.
                      Listo.
                    </td>
                  </tr>
                  <tr className="hover:bg-white/5 transition-colors" data-id="element-295">
                    <td className="p-4 text-gray-300 rounded-bl-xl" data-id="element-296">
                      Pinchás de noche en una zona sin cobertura
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-297">
                      Esperás en el costado de la ruta sin saber
                    </td>
                    <td className="p-4 text-white bg-cyan/5 font-medium rounded-br-xl" data-id="element-298">
                      Protocolo de cambio nocturno seguro y rápido. Listo.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </FadeIn>

        {/* Kit Includes */}
        <FadeIn delay={0.3} data-id="element-299">
          <div className="max-w-4xl mx-auto mb-20 bg-surfaceLight/30 rounded-3xl p-8 border border-white/5" data-id="element-300">
            <h3 className="text-2xl font-bold text-white mb-8 text-center" data-id="element-301">
              ✅ MECÁNICA DE GUERRA 24/7™ INCLUYE:
            </h3>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-302">
              {['🔴 Protocolo de emergencia nocturna en ruta (qué hacer en los primeros 5 minutos)', '⚡ Diagnóstico de fallas eléctricas sin scanner (los 8 síntomas eléctricos más comunes resueltos)', '🌡️ Protocolo anti-recalentamiento de emergencia (cómo actuar sin dañar el motor)', '🔋 Arranque de emergencia sin asistencia (con y sin cables. Con y sin batería auxiliar)', '🔊 Guía de diagnóstico de ruidos en movimiento (qué indica cada ruido, desde dónde viene y qué hacer)', '🛞 Protocolo de cambio de neumático nocturno (seguro, rápido y sin herramientas especiales)', '🚨 Kit de comunicación de emergencia (los números, apps y recursos que necesitás tener ya)', '📋 Checklist de supervivencia en ruta (lo que debe estar en tu auto antes de cada viaje largo)'].map((item, i) => <div key={i} className="flex items-start gap-3 bg-background/50 p-4 rounded-xl border border-white/5" data-id="element-303">
                  <span className="text-gray-300" data-id="element-304">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Testimonials */}
        <FadeIn delay={0.4} data-id="element-305">
          <div className="max-w-5xl mx-auto mb-24" data-id="element-306">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-10 text-center" data-id="element-307">
              ❤️ MÁS CONDUCTORES QUE YA LO TIENEN
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-308">
              {[{
              name: 'Diego F.',
              loc: '📍 Buenos Aires',
              plan: 'Mega Pack Auto Blindado™',
              text: 'Con los Scripts Anti-Mecánico en la primera visita al taller ahorré $75.000. El pack se pagó solo en el primer uso.'
            }, {
              name: 'Laura M.',
              loc: '📍 Mendoza',
              plan: 'Conductora',
              text: 'La Guía de Tablero me salvó de una situación de pánico en la autopista. Ahora sé exactamente qué hacer.'
            }, {
              name: 'Carlos P.',
              loc: '📍 Córdoba',
              plan: 'Conductor',
              text: 'El checklist pre-VTV me hizo aprobar sin ningún gasto extra. Antes siempre salía debiendo algo.'
            }, {
              name: 'Sebastián R.',
              loc: '📍 Rosario',
              plan: 'Mega Pack + Mecánica de Guerra 24/7™',
              text: 'Con Mecánica de Guerra 24/7 me recalenté en ruta y supe exactamente qué hacer. Sin grúa, sin pánico. Llegué solo al taller más cercano.'
            }].map((t, i) => <div key={i} className="bg-surfaceLight p-6 rounded-2xl border border-white/5" data-id="element-309">
                  <div className="flex gap-1 mb-3" role="img" aria-label="Calificación: 5 de 5 estrellas" data-id="element-310">
                    {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-yellow text-yellow" aria-hidden="true" data-id="element-311" />)}
                  </div>
                  <p className="text-gray-300 mb-4 italic" data-id="element-312">"{t.text}"</p>
                  <div className="text-sm" data-id="element-313">
                    <span className="font-bold text-white" data-id="element-314">{t.name}</span>
                    <span className="text-gray-500 mx-2" aria-hidden="true" data-id="element-315">
                      |
                    </span>
                    <span className="text-gray-400" data-id="element-316">{t.loc}</span>
                    <span className="text-gray-500 mx-2" aria-hidden="true" data-id="element-317">
                      |
                    </span>
                    <span className="text-cyan text-xs" data-id="element-318">{t.plan}</span>
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Guarantee */}
        <FadeIn delay={0.5} data-id="element-319">
          <div className="max-w-3xl mx-auto bg-surfaceLight/50 rounded-3xl p-8 md:p-12 border border-white/5 text-center" data-id="element-320">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/5 mb-6" data-id="element-321">
              <ShieldCheck className="w-8 h-8 text-white" aria-hidden="true" data-id="element-322" />
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-323">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h3>
            <p className="text-gray-300 text-lg mb-6" data-id="element-324">
              Abrís los módulos. Los usás en el taller o en la ruta. Si en 7
              días no es lo que esperabas:
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4 mb-6 text-white font-medium" data-id="element-325">
              <div className="flex items-center justify-center gap-2" data-id="element-326">
                <span className="text-green-400" data-id="element-327">✅</span> Devolución del 100%
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-328">
                <span className="text-green-400" data-id="element-329">✅</span> Sin formularios, sin
                drama.
              </div>
            </div>
            <div className="inline-block bg-background px-4 py-2 rounded-lg border border-white/10 text-sm text-gray-400" data-id="element-330">
              Tasa de devoluciones: menos del 1%.
            </div>
          </div>
        </FadeIn>

        {/* FAQ */}
        <FadeIn delay={0.6} data-id="element-331">
          <div className="max-w-3xl mx-auto mt-24" data-id="element-332">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center" data-id="element-333">
              ❓ LO QUE MÁS NOS PREGUNTAN
            </h3>
            <div className="space-y-4" data-id="element-334">
              {faqs.map((faq, i) => <div key={i} className="bg-surfaceLight border border-white/5 rounded-xl overflow-hidden" data-id="element-335">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan focus-visible:ring-offset-2 focus-visible:ring-offset-background" aria-expanded={openFaq === i} aria-controls={`faq-answer-${i}`} data-id="element-336">
                    <span id={`faq-question-${i}`} className="font-medium text-white pr-4" data-id="element-337">
                      {faq.q}
                    </span>
                    <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform shrink-0 ${openFaq === i ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-338" />
                  </button>
                  {openFaq === i && <div id={`faq-answer-${i}`} role="region" aria-labelledby={`faq-question-${i}`} className="px-6 pb-4 text-gray-400" data-id="element-339">
                      {faq.a}
                    </div>}
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}